module.exports = {"selected_device_t":"Seleccionar Dispositiu","partials":{"pot_contracted":"Pot. Contractada","pot_penalty":"Pot. Penalització","api":"Pot. Actual","current_tension":"Tensió actual","api_now":"Potència Activa Instantània","active_reactive":"Energia activa-reactiva","ae":"Energia Activa","ie":"Energia Reactiva","cosi":"Cosinus de Phi Instantàni","historical_active_power":"Històric potència activa","historical_active_reactive_energy":"Històric energia activa-reactiva"}}


//////////////////
// WEBPACK FOOTER
// ./src/translates/cat/Device.json
// module id = 28
// module chunks = 1